import React from 'react'
import classNames from 'classnames'
import moment from 'moment'

const renderMemberAnchors = function (label, prop, linkStart) {
  return (
    <p className="">
      <span className="members-content__item-label">{label}</span>
      {prop ? <a href={linkStart + '' + prop}>{prop}</a> : <span>-</span>}
    </p>
  )
}

const orderOfRoles = ['PO', 'PM', 'ISA', 'BUDGET_APPROVER']
const sortByRoles = (members) => {
  const sorted = members
  sorted.sort((member1, member2) => {
    for (const role of orderOfRoles) {
      if (member1.roles.includes(role) && !member2.roles.includes(role)) {
        return -1
      } else if (
        !member1.roles.includes(role) &&
        member2.roles.includes(role)
      ) {
        return 1
      }
    }
    return member1.firstName > member2.firstName ? 1 : -1
  })
  return sorted
}

// Tenant members render
const renderMembers = function (members, isEditable) {
  const shouldHighlight = ['PO', 'PM', 'BUDGET_APPROVER', 'ISA']
  const highlightText = (member) => {
    const { roles } = member
    return (
      // prettier-ignore
      roles
        .filter((role) => shouldHighlight.includes(role))
        .map((role) => role === 'BUDGET_APPROVER' ? 'BA' : role)
        .join(' ') || ''
    )
  }

  if (!members || !members.length) {
    return <p>-</p>
  }

  return sortByRoles(members).map((member) => {
    const badge = highlightText(member)
    const generateMemberRoles = (roles) => {
      const sortedRoles = roles.sort((a, b) => {
        const textA = a.toUpperCase()
        const textB = b.toUpperCase()
        return textA < textB ? -1 : textA > textB ? 1 : 0
      })
      return sortedRoles.map((role) => (
        <span className="wb-tag wb-tag--tertiary wb-margin-3xs" key={role}>
          {role}
        </span>
      ))
    }
    return (
      <div
        className={classNames(
          'members-content__item members-content__item--flex members-content__item--highlight wb-margin-vertical-xxs',
          {
            'members-content__item--expired': moment(
              member.tenantMemberUntil,
            ).isBefore(moment.now()),
          },
        )}
        key={`${member.daimlerId}_${member.email}`}
      >
        <div>
          {!!badge && (
            <div className="members-content__badge">
              {badge.split(' ').map((badg) => (
                <span
                  key={badg}
                  className="wb-tag wb-tag--tertiary wb-margin-3xs"
                >
                  {badg}
                </span>
              ))}
            </div>
          )}
          {/* role and name */}
          <p className="">
            <span className="members-content__item-label">Name</span>
            {member.firstName && `${member.firstName} ${member.lastName}`}
          </p>
          <p className="members-content__item__row">
            <span className="members-content__item-label">Roles</span>
            {generateMemberRoles(member.roles)}
          </p>
          {member.comment && (
            <p>
              <span className="members-content__item-label">Comment</span>
              {member.comment}
            </p>
          )}

          {renderMemberAnchors(
            'DaimlerId',
            member.daimlerId,
            'https://teams.app.corpintra.net/teams/person/',
          )}
          {renderMemberAnchors(
            'MBioId',
            member.mbioId,
            'https://confluence.mercedes-benz.io/display/~',
          )}
          {renderMemberAnchors('Email', member.email, 'mailto:')}
          <p className="members-until">
            <span className="members-content__item-label">Member Until</span>
            {member.tenantMemberUntil}
          </p>
        </div>
        <hr />
        <div className="members-content__item--scroll-container">
          <p className="wb-padding-start-xxs">
            <span className="members-content__item-label">
              Member permissions:
            </span>
          </p>
          <div>
            {member.permissions ? (
              Object.keys(member.permissions).map((pkg) => (
                <div
                  className="members-content__item-label members-content__item--black wb-margin-start-xxs"
                  key={pkg}
                >
                  {pkg}
                  <ul className="wb-list wb-list--offset-m wb-list--unordered">
                    {member.permissions[pkg].map((perm) => (
                      <li className="wb-list__item" key={perm}>
                        {perm}
                      </li>
                    ))}
                  </ul>
                </div>
              ))
            ) : (
              <span className="members-content__item-label wb-margin-start-xxs">
                N/A
              </span>
            )}
          </div>
        </div>
      </div>
    )
  })
}

export const TenantMembersComponent = function (props) {
  const { currentTenantMembers, isEditable } = props

  return (
    <div className="tenant-body__block members">
      <label className="tenant-body__block-label">Members</label>
      <div className=" members-content">
        {renderMembers(currentTenantMembers, isEditable)}
      </div>
    </div>
  )
}
